import store from '@/store/index'
/**
 * 实验须知model
 */
import {getKnowConfig, setRead, judgeKnowRead} from "@/api/exp/KonwConfigApi";
import {LoginModel} from "@/model/exp/LoginModel";

class KnowConfigModel {
    // 获取信息
    static async getInfo() {
        let [data] = await getKnowConfig()
        return data.data;
    }

    // 判断实验须知是否已读
    static async judgeRead() {
        let [res] = await judgeKnowRead()
        if (res.code === 20000) {
            return res.data
        } else {
            return false
        }
    }

    // 设置实验须知已读
    static async setRead(userInfo) {
        let [data] = await setRead()
        return true
    }
}

export {KnowConfigModel}
